import React from 'react';
import classnames from 'classnames';
import { Table } from 'semantic-ui-react';
import '../../../App.css';

const TableItems = ({ item }) => {
  const { referencia, orden, fecha_recepcion, resultado, unidad } = item;
  let result =
    resultado === null
      ? '0.0'
      : Number(resultado.toString().match(/^\d+\.?\d{0,2}/g));

  const referencias = referencia.split(' - ');
  return (
    <Table.Row>
      <Table.Cell>{orden}</Table.Cell>
      <Table.Cell>{fecha_recepcion}</Table.Cell>
      <Table.Cell
        className={classnames({
          'table-red-mark': result < referencias[0] || result > referencias[1]
        })}
      >
        {result}
      </Table.Cell>
      <Table.Cell>{unidad}</Table.Cell>
    </Table.Row>
  );
};

export default TableItems;
